import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Care() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data));
  }, []);

  return (
    <div data-testid="care-page" className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28">
      <p className="smallcaps mb-3">Workshop Notes</p>
      <h1 className="font-display text-5xl sm:text-6xl text-[#212121] mb-6">Care & Journal</h1>
      <p className="text-[#757575] max-w-2xl mb-16 leading-relaxed">
        Everything you need to know to keep a hand-crafted board looking — and feeling — like the day it came out of the workshop.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
        {posts.map((p) => (
          <Link
            to={`/care/${p.slug}`}
            key={p.id}
            data-testid={`blog-${p.slug}`}
            className="group block"
          >
            {p.cover_image && (
              <div className="aspect-[4/3] overflow-hidden border border-[#B2DFDB] mb-4">
                <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
            )}
            <p className="smallcaps mb-2">Journal</p>
            <h3 className="font-display text-2xl text-[#212121] mb-2 group-hover:text-[#B87333] font-bold transition-colors leading-tight">{p.title}</h3>
            <p className="text-[#757575] text-sm">{p.excerpt}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
